import React, { FC } from "react";
import { AppBar, Box, Stack, Toolbar, Typography } from "@mui/material";
import { NavLink } from "react-router";

import DDBIcon from "./DDBIcon";
import Refresh from "./Refresh";

const NavigationBar: FC = () => {
  return (
    <AppBar position="static" color="transparent" data-testid="navigation-bar">
      <Toolbar>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", padding: 4 }}>
          <Stack
            data-testid="navigation-bar-link"
            component={NavLink}
            to="/"
            sx={{ textDecoration: "none", color: "inherit", flexGrow: 1 }}
            direction="row"
            spacing={4}
            alignItems="center"
            justifyContent="start"
          >
            <DDBIcon />
            <Stack direction="column" spacing={0.2} justifyContent="start" alignItems="start">
              <Typography variant="h6">Digital Design Brief</Typography>
              <Typography variant="overline">EXCEL CONNECTOR</Typography>
            </Stack>
          </Stack>
          <Refresh />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default NavigationBar;
